import { TicklerService } from './../../tickler.service';
import { DashboardService } from '@page/dashboard/dashboard.service';

import { LocationService } from './../../../core/services/location.service';
import { filter, Subscription } from 'rxjs';

import { SessionStorageService } from './../../../core/services/session-storage.service';

import { Router } from '@angular/router';
import { Component, OnInit, ViewChild, ElementRef, AfterViewInit, ViewEncapsulation } from '@angular/core';
import { FormGroup, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { RnfiConfigService } from '@rnficonfig/config.service';
import { NgxToasterService } from '@core/services/toasterNgs.service';
import { chekValueIsNumberOrNot, validateEmail } from '@core/common/common-function';
import { AuthCoreService } from '../auth.service';
import { regExpNativePatternValidator } from '@core/utility/validator';
import { regExpPattern } from '@core/validators/regExpPatternList';
import { UtilityService } from '@core/services/utility.service';
import { TosterService } from '@core/services/toster.service';
import { TemplateModalOverlayRef } from '@features/customCDK/cdkCustomMdl/classes/template-modal.ref';
import { CustomOverlayConfig, TemplateModalService } from '@features/customCDK/cdkCustomMdl/services/template-modal.service';
import { TemplatePortal } from '@angular/cdk/portal';
import { UserDetailsService } from '@core/services/user-details.service';
import { CommonService } from '@core/services/common.service';
import { AutoLogoutService } from '@features/autoLogout/service/auto-logout.service';
import { ConfirmationModalConfig, ConfirmationModalService } from '@features/customCDK/cdkCustomMdl/services/confirmation-modal.service';
import { ConfirmationComponent } from '@features/customCDK/cdkCustomMdl/components/confirmation/confirmation.component';
import { ConfirmationModalOverlayRef } from '@features/customCDK/cdkCustomMdl/classes/confirmation-modal.ref';
import {PermissionServiceService} from "@core/services/permission-service.service";
import { SidebarService } from '@features/layouts/components/sidebar/sidebar-service.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})

export class LoginComponent implements OnInit, AfterViewInit {
  @ViewChild('modalTemplate') modalTemplate!: TemplatePortal<any>;

  @ViewChild('ss') ss: ElementRef;
  ttl: string = 'Login to Dashboard';
  isOtpBoxShow: boolean = false;
  userLat: any = null;
  userLang: any = null;
  showOtpBtn: boolean = false;
  isOtpSend: boolean = false;
  maskMobileNo: string = '';
  loginGroup: FormGroup = this.fb.group({
    loginTypeId: ['1', [Validators.required]],
    email_phone: ['', [Validators.minLength(5), regExpNativePatternValidator(
      (obj: any) => {
        this.showOtpBtn = false;
        if (obj.value.length > 5 && (new RegExp(
          regExpPattern['email']
        ).test(obj.value) || new RegExp(
          regExpPattern['mobile']
        ).test(obj.value) || new RegExp(
          regExpPattern['alphanumeric']
        ).test(obj.value))) {
          if (new RegExp(
            regExpPattern['email']
          ).test(obj.value)) {
            this.ttl = 'Login With Email';
            this.showOtpBtn = false;

            // this.loginGroup.get('loginTypeId')?.setValue('1');
          } else if (new RegExp(
            regExpPattern['mobile']
          ).test(obj.value)) {
            this.ttl = 'Login With Mobile';
            this.showOtpBtn = true;
            // this.loginGroup.get('loginTypeId')?.setValue('1');
          } else if (new RegExp(
            regExpPattern['alphanumeric']
          ).test(obj.value)) {
            this.showOtpBtn = false;
            this.ttl = 'Login With User Name';
            // this.loginGroup.get('loginTypeId')?.setValue('1');
          }
          if (this.showOtpBtn) {
            this.loginControls['password'].disable();
          }else{
            this.loginControls['password'].enable();
          }
          obj.callBack(true);
        } else {
          this.ttl = 'Login to Dashboard'
          obj.callBack(false);
        }
      },
      {
        termconditionError: () => `Enter User ID, Email ID or Mobile Number.`,
      }
    ),]],
    password: ['', [Validators.required, Validators.minLength(8)]],
    otp: ['']
  });

  submitted = false;
  loginTypeList: any[] = [];
  amountDataSubscription: Subscription;
  loginSubscription: Subscription
  userId: number;
  btnName: string = "Verify OTP";

  private templateRef!: TemplateModalOverlayRef;
  customConfig!: CustomOverlayConfig;
  isResendOtp: boolean = false;
  latitude: any;
  longitude: any;
  confirmationRef: ConfirmationModalOverlayRef;

  constructor(
    private _rnfiConfigService: RnfiConfigService,
    private fb: UntypedFormBuilder,
    private route: Router,
    private ngrxToaster: NgxToasterService,
    private toater: TosterService,
    private authService: AuthCoreService,
    private sessionStorage: SessionStorageService,
    private _UtilityService: UtilityService,
    private locationService: LocationService,
    private _TemplateModalService: TemplateModalService,
    private _CommonService: CommonService,
    private dashboardService: DashboardService,
    private userDetailsService: UserDetailsService,
    private _AutoLogoutService: AutoLogoutService,
    private _ConfirmationModalService: ConfirmationModalService,
    private _TicklerService: TicklerService,
    private _permissionService: PermissionServiceService,
    private _sidebarService: SidebarService
  ) {

    this._rnfiConfigService.config = {
      layout: {
        navbar: {
          hidden: true
        },
        header: {
          hidden: true
        },
        footer: {
          hidden: true
        },
        news: {
          hidden: true
        },
        sidepanel: {
          hidden: true
        },
        content: {
          hidden: true
        },
        slider: {
          hidden: true
        },
      }
    };
    this.locationService.seterLocation.subscribe((letLang: any) => {
      if (letLang) {
        this.longitude = letLang.long;
        this.latitude = letLang?.lat;
      }
    })
  };

  ngOnInit(): void {
    this._sidebarService.sideBarList.next(null);
    this.loginGroup.get('loginTypeId')?.valueChanges.subscribe((val: any) => {
      this.isOtpBoxShow = false;
      this.loginGroup.patchValue({
        password: '',
        otp: '',
      })

      if (val == '1') {

        this.loginControls['password'].enable();
        this._UtilityService.setRemoveValidator(
          'a',
          this.loginGroup,
          [
            'password',
          ],
          Validators.required
        );
      } else {

      }

    })
  };

  rormSetRemoveValidator(type: 'r' | 'a', control: string) {
    let innerForm: FormGroup = this.loginGroup as FormGroup;
    this._UtilityService.setRemoveValidator(
      type,
      innerForm,
      control,
      Validators.required
    );
  }

  public ngAfterViewInit(): void {

    this.ss.nativeElement.focus();
    setTimeout(() => { console.log(this.loginGroup.value); }, 500)

  }

  get loginControls() {
    return this.loginGroup.controls;
  };



  setLoginPayload() {
    // data to send in payload
    let formData = this.loginGroup.value;
    //console.log(formData);

    let data = new FormData();
    data.append('type', formData.loginTypeId);
    data.append('email_phone', formData.email_phone);
    data.append('password', formData.password ?? '');
    data.append('latitude', this.latitude);
    data.append('longitude', this.latitude);
    return data;
  };

  loginUser() {

    this.loginSubscription = this.authService.login({ 'payload': this.setLoginPayload(), 'form': this.loginGroup }).subscribe((resp: any) => {
      if (resp && resp.statuscode == 200) {
        if (resp.responsecode == 3) {
          resp['authtoken'] = resp.data.token;
          console.log('setting session');
          this.userDetailsService.setUserLoginDetails = resp;
          this.route.navigate(['change-password']);
        } else
          if (resp.responsecode == 2) {
            this.ngrxToaster.showInfo(resp.message, undefined);
            if (this.isResendOtp) {
              return;
            }
            this.isOtpSend = true;
            this.openOTPModal();
            this.maskMobileNo = `We have sent an OTP to the registered mobile number ${resp.data.phone}`
          } else if (resp.responsecode == 1) {
            if (this.isOtpSend) {
              this.closeTemplateModal()
            }
            this.redirectDashboard(resp)

          } else {
            this.openSubmitConfirmationModal(resp.message)
          }

      } else {
        this.ngrxToaster.showError(resp.message, undefined)
      }
    })
  }

  openSubmitConfirmationModal( message?: string) {
    //console.log("modal clicked")
    let customConfig: ConfirmationModalConfig = {
      data: {
        icon: 'error',
        title: 'Sorry!',
        title2: '',
        msg: message,
        btnConfirm: '',
        btnClose: 'Ok'
      },
    };

    this.confirmationRef =
      this._ConfirmationModalService.open<ConfirmationComponent>(
        ConfirmationComponent,
        customConfig
      );
    this.confirmationRef.events.pipe(
      filter((event) => {
        //console.log(event);
        return !!event
      }),
    ).subscribe((events) => {
      switch (events.type) {
        case 'confirm':
          //console.log('confirmed action, proceed');

          break;
        case 'close':
          //console.log('close modal');
          this.confirmationRef.close(customConfig);
          break;
      }
    });

  };

  sendOtp() {
    //console.log(this.loginControls['password']);
    this.loginGroup.get('loginTypeId')?.setValue('2');
    this.loginControls['password'].disable();
    this.loginUser();
  }
  verifyOtp(otp: any) {
    if (!otp) {
      this.ngrxToaster.showInfo("please enter OTP", "Info")
      return;
    }
    const data = new FormData();
    data.append('email_phone', this.loginGroup.value.email_phone);
    data.append('otp', otp);
    data.append('latitude', this.latitude);
    data.append('longitude', this.latitude);
    this.authService.verifyOtp(data).subscribe((res: any) => {
      if (res && res.statuscode == 200 && res.status) {
        if (res.responsecode == 3) {
          this.closeTemplateModal()
          res['authtoken'] = res.data.token;
          this.userDetailsService.setUserLoginDetails = res;
          this.route.navigate(['change-password']);
        }
          else if (res.responsecode == 1) {
            this.ngrxToaster.showSuccess(res.message, "Success");
            this.closeTemplateModal()
            this.redirectDashboard(res)

          } else {

          }

      } else {
        this.ngrxToaster.showError(res.message, undefined);
      }
    }
    )
  };

  redirectDashboard(res) {
    this.ngrxToaster.showSuccess(res.message, undefined);
    this.userDetailsService.setUserLoginDetails = res;
    this.route.navigate(['dashboard']);
    setTimeout(() => {
      this.dashboardService.dashboardCall.emit(true);
    }, 1);
  }


  async sendOTP(isResendOtp: boolean) {
    this.isResendOtp = true;
    this.loginUser();
  }

  openOTPModal() {
    this.customConfig = {};
    this.templateRef = this._TemplateModalService.open(this.modalTemplate, {}, this.customConfig);
    this.templateRef.afterClosed$.subscribe((val) => {
      //console.log(val);

      if (val.type == 'ok') {

      } else {
        this.showOtpBtn = false;

        this.loginGroup.reset({
          loginTypeId: '1',
          email_phone: '',
          password: '',
          otp: '',
        });
        this.loginControls['password'].enable();

        this.loginGroup.get('loginTypeId')?.setValue('1');


      }
    })
  }
  closeTemplateModal($event?: CustomOverlayConfig) {
    this.templateRef.close(this.customConfig);
  }
}
